import { fetchBlogs, fetchTagsFilter, fetchLandingBlogs } from '../../util/api';
import { getStrapiLocale } from '../../util/genericHelpers';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //

export const SEARCH_BLOGS_REQUEST = 'app/BlogPage/SEARCH_BLOGS_REQUEST';
export const SEARCH_BLOGS_SUCCESS = 'app/BlogPage/SEARCH_BLOGS_SUCCESS';
export const SEARCH_BLOGS_ERROR = 'app/BlogPage/SEARCH_BLOGS_ERROR';

export const FETCH_LANDING_BLOGS_REQUEST = 'app/BlogPage/FETCH_LANDING_BLOGS_REQUEST';
export const FETCH_LANDING_BLOGS_SUCCESS = 'app/BlogPage/FETCH_LANDING_BLOGS_SUCCESS';
export const FETCH_LANDING_BLOGS_ERROR = 'app/BlogPage/FETCH_LANDING_BLOGS_ERROR';

const defaultLocale = getStrapiLocale() || 'el-GR';

// ================ Reducer ================ //

const initialState = {
  searchInProgress: false,
  blogsData: [],
  blogTags: [],
  searchBlogsError: null,
  landingBlogsData: [],
  landingBlogsLoading: false,
  landingBlogsError: null,
};

const blogsPageReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_BLOGS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
      };
    case SEARCH_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        blogsData: payload?.data || [],
        blogTags: payload?.data?.filters || [],
      };
    case SEARCH_BLOGS_ERROR:
      return { ...state, searchInProgress: false, searchBlogsError: true };
    case FETCH_LANDING_BLOGS_REQUEST:
      return {
        ...state,
        landingBlogsLoading: true,
        landingBlogsError: null,
      };
    case FETCH_LANDING_BLOGS_SUCCESS:
      return {
        ...state,
        landingBlogsLoading: false,
        landingBlogsData: payload?.blogs || [],
      };
    case FETCH_LANDING_BLOGS_ERROR:
      return {
        ...state,
        landingBlogsLoading: false,
        landingBlogsError: true,
      };
    default:
      return state;
  }
};

export default blogsPageReducers;

// ================ Selectors ================ //

export const fetchBlogsSelector = state => state.BlogPage.blogsData?.blogs;

// ================ Action creators ================ //

export const searchBlogsRequest = () => ({
  type: SEARCH_BLOGS_REQUEST,
});

export const searchBlogsSuccess = response => ({
  type: SEARCH_BLOGS_SUCCESS,
  payload: { data: response },
});

export const searchBlogsError = () => ({
  type: SEARCH_BLOGS_ERROR,
});

export const fetchLandingBlogsRequest = () => ({
  type: FETCH_LANDING_BLOGS_REQUEST,
});

export const fetchLandingBlogsSuccess = response => ({
  type: FETCH_LANDING_BLOGS_SUCCESS,
  payload: response,
});

export const fetchLandingBlogsError = () => ({
  type: FETCH_LANDING_BLOGS_ERROR,
});

export const fetchAllBlogs = params => async (dispatch, getState, sdk) => {
  dispatch(searchBlogsRequest());

  try {
    const [blogsResponse, tagsResponse] = await Promise.all([
      fetchBlogs({ ...params, defaultLocale }),
      fetchTagsFilter({ ...params, defaultLocale }),
    ]);
    dispatch(searchBlogsSuccess({ blogs: blogsResponse?.blogs, filters: tagsResponse?.tags }));
  } catch (error) {
    dispatch(searchBlogsError());
  }
};

export const loadData = (params, search) => {
  const parsedSearch = search && parse(search);
  return fetchAllBlogs({ tags: parsedSearch?.tags });
};

export const fetchLandingBlogsData = (locale = 'en') => async (dispatch, getState, sdk) => {
  dispatch(fetchLandingBlogsRequest());

  try {
    const strapiLocale = locale === 'el' ? 'el-GR' : locale;

    const response = await fetchLandingBlogs({ defaultLocale: strapiLocale });

    dispatch(fetchLandingBlogsSuccess({ blogs: response?.blogs || [] }));
  } catch (error) {
    dispatch(fetchLandingBlogsError());
  }
};
